// extracted by mini-css-extract-plugin
export var arrows = "_4x-6";
export var decrementer = "_4x-a";
export var disabled = "_4x-4";
export var error = "_4x-1";
export var hiddenText = "_4x-b";
export var incrementer = "_4x-9";
export var input = "_4x-8";
export var inputWrapper = "_4x-0";
export var leadingIcon = "_4x-c";
export var readonly = "_4x-3";
export var regular = "_4x-7";
export var small = "_4x-5";
export var warning = "_4x-2";